import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, X, ArrowRight } from 'lucide-react';
export function ScrollQuoteBar() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (sessionStorage.getItem('lp_scroll_bar_dismissed') === '1') {
      setDismissed(true);
      return;
    }
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const threshold = isMobile ? 0.4 : 0.3;
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      const pct = window.scrollY / max;
      setVisible(pct >= threshold);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const close = () => {
    setDismissed(true);
    try {
      sessionStorage.setItem('lp_scroll_bar_dismissed', '1');
    } catch {}
  };
  if (dismissed) return null;
  return <AnimatePresence data-id="element-660">
      {visible && <motion.div initial={{
      y: -60,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -60,
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed top-0 left-0 right-0 z-[60] bg-brand text-white shadow-lg" role="region" aria-label="Quote callout" data-id="element-661">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-12 flex items-center justify-between gap-4" data-id="element-662">
            <div className="flex items-center gap-3 min-w-0" data-id="element-663">
              <span className="hidden sm:flex w-2 h-2 rounded-full bg-success animate-pulse flex-shrink-0" data-id="element-664"></span>
              <span className="text-sm font-semibold truncate" data-id="element-665">
                <span className="hidden sm:inline" data-id="element-666">Free quote from Mike. </span>
                Same day callback.
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-667">
              <a href="tel:+61864043888" className="hidden md:flex items-center gap-1.5 text-sm font-bold hover:text-accent transition-colors" aria-label="Call Langler Air" data-id="element-668">
                <Phone size={13} strokeWidth={2.5} data-id="element-669" />
                <span className="tabular-nums" data-id="element-670">08 6404 3888</span>
              </a>
              <a href="#quote-form" className="inline-flex items-center gap-1 h-8 px-3 rounded-lg bg-accent hover:bg-accent-600 text-ink-900 text-xs font-bold transition-all hover:scale-[1.03]" data-id="element-671">
                Get Quote
                <ArrowRight size={12} strokeWidth={2.5} data-id="element-672" />
              </a>
              <button onClick={close} className="p-1 -mr-1 hover:opacity-80 transition-opacity" aria-label="Dismiss" data-id="element-673">
                <X size={16} data-id="element-674" />
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}